import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class ValidaCambioPassService implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (sessionStorage.getItem('docUsuario')) {
      return true;
    } else {
      // Si no esta activa la sesion, redirecciona al login
      this.router.navigate(['login']);
      return false;
    }

  }

}